export * from "#static-schema";
export * as staticSchema from "#schema";
export {
  CREATE_WORD_DEFINITION_FTS_SQL,
  POPULATE_WORD_DEFINITION_FTS_SQL,
  WORD_DEFINITION_FTS_STATEMENTS,
  WORD_DEFINITION_FTS_TABLE,
} from "#word-definition-fts";
